// extracted by mini-css-extract-plugin
module.exports = {"revision-modal":"revision-modal_revision-modal__0UZwm","scroll-col":"revision-modal_scroll-col__FnjES"};